import React from 'react'
import './Login.css';

import Logo from '../../assets/images/Logo.jpg'
import { Link } from 'react-router-dom';
import LoginBg from '../../assets/images/LoginBg.jpg';

const Login = () => {

  return (
    <>
      <style>
        {`
          .HeaderSection {
            display: none;
          }

          .FooterSection {
            display: none;
          }
        `}
      </style>
      <section className='LoginPageSection'>
        <div className='LoginPageSectionBg' style={{ backgroundImage: `url(${LoginBg})` }}></div>
        <div className='container'>
          <div className='row'>
            <div className='col-md-12 col-sm-12 col-xs-12'>
              <div className='LoginPageBox'>
                <img src={Logo} alt="" />
                <form action="">
                  <h4>Login</h4>

                  <div className='form-group'>
                    <label htmlFor="">Username</label>
                    <input type="text" placeholder='Enter username' />
                  </div>

                  <div className='form-group'>
                    <label htmlFor="">Password</label>
                    <input type="text" placeholder='Enter password' />
                  </div>

                  <div className='form-group mb-0'>
                    <button className='LoginButton'>Sign in</button>
                  </div>
                </form>
                <Link to='/' className='backtohomeTxt'> <i class="fas fa-angle-double-left"></i> Back to home</Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

export default Login